<template>
	<div class="loading-spinner">
		<div class="loading-spinner-icon" v-if="type === 'circle'">
			<fa-icon icon="circle-notch" spin />
		</div>
		<div class="loading-spinner-logo" v-if="type === 'logo'">
			<img :src="logoSrcS(true)">
		</div>
		<div class="loading-spinner-svg" v-if="type === 'svg'">
			<inline-svg :src="logoSrcSSvg(`logo${$store.state.CID}`)"></inline-svg>
		</div>
	</div>
</template>

<script>
import InlineSvg from 'vue-inline-svg';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';

export default {
	name: 'LoadingSpinner',
	mixins: [staticDataLoaderMixin],
	components: { InlineSvg },
	props: {
		type: {
			required: false,
		},
	},
};
</script>

<style src="@/styles/components/LoadingSpinner/LoadingSpinner.less" lang="less" scoped></style>
